import { render, staticRenderFns } from "./CreateLeagueModalWrapper.vue?vue&type=template&id=08ea77ec"
import script from "./CreateLeagueModalWrapper.vue?vue&type=script&lang=js"
export * from "./CreateLeagueModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports